import React from "react";
import { Layout } from "../../layouts/Layout";
import { useTranslation } from "react-i18next";
import { ContactAreaInner } from "../../components/ContactAreas/ContactAreaInner";
import { CtaAreaTwo } from "../../components/CtaAreas/CtaAreaTwo";
import { BlogAreaThree } from "../../components/BlogAreas/BlogAreaThree";

const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <Layout breadcrumb={t("pages.contact.breadcrumb")} title={t("pages.contact.title")}>
      {/* contact-area */}
      <ContactAreaInner />

      {/* cta-area */}
      <CtaAreaTwo />

      {/* blog-area */}
      <BlogAreaThree />
    </Layout>
  );
};

export default ContactPage;
